import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_annual_medical_examinations_done_on_food_service'

export const dataPointDefinition = {
  retracedId: 'no_annual_medical_examinations_done_on_food_service',
  name: 'No annual medical examinations done on food service workers to ensure they are healthy and free from communicable diseas',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-can-8x',
      number: 'HS-CAN-3-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-can-3',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],fp-bs-7,Yes. Canteen only.;Yes. Canteen and eating area.',
      machineShowHide: '[2],fp-bs-7,2;3',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-can-8x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30030,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
